import { render, staticRenderFns } from "./SurveyStructContainer.vue?vue&type=template&id=143250c7&"
import script from "./SurveyStructContainer.vue?vue&type=script&lang=js&"
export * from "./SurveyStructContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports